import { faUserCircle } from "@fortawesome/free-solid-svg-icons/faUserCircle";
import { Tooltip } from "../utils/local-antd";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { User } from "../model/user/User";
import { useAppSelector } from "../redux/store";
import { userSliceSelectors } from "../redux/user/user.selector";
import { Rounded } from "../theme/Rounded";
import { AtiraIcon } from "./AtiraIcon";
import { Flex } from "./Flex";
import { Spacing } from "../theme/Spacing";
import { ImageCreateEdit } from "./ImageCreateEdit";

const OverlapWrapper = styled.div<{ withName?: boolean }>`
  display: flex;
  align-items: center;

  ${({ withName }) =>
    !withName &&
    `
      > * {
        margin-inline-start: -${Spacing.s};
        &:first-child {
          margin-inline-start: 0;
        }
        box-shadow: 0 0 0 2px #fff; 
        position: relative;
        z-index: 1;
      }
      > *:nth-child(2) { z-index: 2; }
      /* > *:nth-child(3) { z-index: 3; } */
    `}
`;

const Container = styled(Flex)`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: ${Rounded.circle};
  overflow: hidden;
  background-color: ${({ theme }) => theme.sub};

  svg,
  img {
    width: 100%;
    height: 100% !important;
  }

  img {
    object-fit: cover !important;
    border: 0.5px solid ${({ theme }) => theme.main};
    border-radius: ${Rounded.circle};
  }
`;

type AssigneeBannerProps = {
  assignees?: Partial<User>[];
  displayName?: boolean;
  hideSelf?: boolean;
  title?: string;
};

export const AssigneeBanner: React.FC<AssigneeBannerProps> = ({
  assignees: _assignees,
  displayName = false,
  hideSelf,
  title,
}) => {
  const { t } = useTranslation();

  const user = useAppSelector(
    userSliceSelectors.selectLoggedInUser,
  )! as Partial<User>;

  const assignees = (hideSelf ? [] : [user]).concat(_assignees || []);

  // if (displayName) {
  //   return (
  //     <Flex alignItems="center" gap="s">
  //       <OverlapWrapper withName>
  //         {assignees.map((assignee, index) => (
  //           <Fragment key={assignee?._id}>
  //             <Container>
  //               {assignee?.picture ? (
  //                 <AtiraImage src={assignee.picture} />
  //               ) : (
  //                 <AtiraIcon icon={faUserCircle} color="main" />
  //               )}
  //             </Container>

  //             <TextWithTruncated length={15} fontSize="s">
  //               {assignee?.name!}
  //             </TextWithTruncated>
  //           </Fragment>
  //         ))}
  //       </OverlapWrapper>
  //     </Flex>
  //   );
  // }

  return (
    <Tooltip
      title={
        title ||
        t("common.assignedTo", {
          name: assignees
            .map((a) => a?.name)
            .filter(Boolean)
            .join(", "),
        })
      }
    >
      <OverlapWrapper>
        {assignees.map((assignee, index) => (
          <Container key={assignee?._id}>
            {assignee?.picture ? (
              <ImageCreateEdit src={assignee.picture} alt={assignee.name} />
            ) : (
              <AtiraIcon icon={faUserCircle} color="main" />
            )}
          </Container>
        ))}
      </OverlapWrapper>
    </Tooltip>
  );
};
